<template>
    <o-tabs class="eml-mail-controls-box" v-model="activeTab">
        <o-tab-item class="info" :value="0">
            <ul class="actions">
                <li>
                    <a @click.prevent="$emit('add-to-work')" href="#">{{
                        addToWorkText
                    }}</a>
                </li>
                <li class="separator" />
                <li v-for="(reference, key) in references" :key="key">
                    <router-link
                        :to="{
                            name: `${reference.reference_type}s.show.emails`,
                            params: { slug: reference.reference_id },
                        }"
                        >{{ reference.reference_title }}</router-link
                    >
                </li>
            </ul>
            <slack-channel-box />
        </o-tab-item>


    </o-tabs >
</template>

<script>
import CreateTask from '../../components/modals/CreateTask'
import { SlackChannelBox } from '../../modules/slack/components'
import {mapActions} from "vuex";

export default {
    components: {
        SlackChannelBox,
    },
    data() {
        return {
            activeTab: 0,
            references: [],
        }
    },
    methods: {
      ...mapActions(['fetchReferences']),
        newTask() {
            this.openModalComponent(CreateTask, { project_id: {}, project_service_id: 12, })
        },
    },
    props: ['addToWorkText', 'references'],
    watch: {
        references(value) {
          console.log(value)
        },
    },
}
</script>

<style lang="sass">
.eml-mail-controls-box
  ul li.separator
    margin: 8px 0
  .tab-content
    padding: 0
    .info
      .actions, .title
        text-align: center
      .title
        margin-bottom: 1rem
        margin-top: 1.5rem
        padding-bottom: 0
</style>